import { Component, inject, signal } from '@angular/core';
import { ModalService } from '@shared/services/modal.service';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalInterface } from '@shared/interfaces/modal.interface';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-alert',
  imports: [CommonModule, MatIconModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css',
})
export class AlertComponent {
  private modalService = inject(ModalService);
  modalSignal = signal<ModalInterface | null>(null);
  effect = signal(false);
  timer!: ReturnType<typeof setTimeout>;

  get modal() {
    return this.modalSignal();
  }

  constructor() {
    this.modalService.modal$
      .pipe(
        filter(modal => modal.show),
        takeUntilDestroyed()
      )
      .subscribe(modal => {
        this.modalSignal.set(modal);
        this.close(modal.time || 3000);
      });
  }

  close(time: number) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.effect.set(true);
      setTimeout(() => {
        this.modalSignal.set(null);
        this.effect.set(false);
      }, 500);
    }, time);
  }

  getAlertDisplay(type: string | undefined) {
    switch (type) {
      case 'WARNING':
        return 'warning';
      case 'ERROR':
        return 'cancel';
      case 'SUCCESS':
        return 'done';
      default:
        return 'cancel';
    }
  }
}
